import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AttendanceStatus } from 'app/library/module-event-attendance/enums/attendance-status.enum';
import { AttendanceStatuses } from 'app/library/module-event-attendance/models/attendance-status';
import { ModuleEventAttendanceService } from 'app/library/module-event-attendance/services/module-event-attendance.service';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';

@Component({
    selector: 'app-course-attendance-dialog',
    templateUrl: './course-attendance-dialog.component.html',
    styleUrls: ['./course-attendance-dialog.component.scss'],
    animations: fuseAnimations,
})
export class CourseAttendanceDialogComponent {
    @Input()
    moduleName: string;

    attendanceStatuses = AttendanceStatuses;
    AttendanceStatus = AttendanceStatus;

    constructor(public dialogRef: MatDialogRef<CourseAttendanceDialogComponent>, public moduleEventAttendance: ModuleEventAttendanceService) {}
}
